import { Box, Toolbar } from '@mui/material';
import Header from '~/components/Header';
import OpenInViewerDownloader from '~/hooks/openInViewer/OpenInViewerDownloader';
import PatientListScreen from './PatientListScreen';

/**
 * Layout mount for the connector-next patient list screen.
 *
 * The route sits behind the app's authentication guard and access-rights
 * check; where MSAL is unconfigured those are no-ops and the screen is
 * reachable directly.
 */
export default function PatientListRoute() {
    return (
        <>
            <Header />
            <Box
                display="grid"
                gridTemplateRows="auto 1fr"
                height="100vh"
                overflow="hidden"
            >
                {/* Spacer under the fixed AppBar (app-wide layout pattern). */}
                <Toolbar variant="dense" />
                <OpenInViewerDownloader>
                    <PatientListScreen />
                </OpenInViewerDownloader>
            </Box>
        </>
    );
}
